module.exports = __webpack_public_path__ + "media/src/images/abouts/items/delivery/dadway-870420a8e8a1a53458c8570995aaa994.jpeg";